import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';
import { CustomClipboard } from 'src/app/core/services/clipboard/clipboard.service';

@Component({
  selector: 'app-bulk-error-modal',
  templateUrl: './bulk-error-modal.component.html',
  styleUrls: ['./bulk-error-modal.component.scss']
})
export class BulkErrorModalComponent implements OnInit {

  @Input() bulkErrorItems: string[];
  @Input() errorMessage: string;

  @Output() closeModal = new EventEmitter<boolean>();

  constructor(
    private scroll: WindowScrollService,
    private snackbarService: SnackbarService,
    private clipboard: CustomClipboard) { }

  ngOnInit(): void {
    this.scroll.disable();
  }

  clickClose(): void {
    this.scroll.enable();
    this.closeModal.emit(false);
  }

  copyTranferFacs() {
    return this.clipboard.writeText(this.bulkErrorItems.join(', ').replace(/,/g,'\r\n')).then( () => {
      this.snackbarService.show('Cópia realizada', 'success');
    });
  }

  customSort(event: number): void {
    if (event === 0) {
      return
    }
    if (event === 1) {
      this.bulkErrorItems.sort();
    }
    if (event === 2) {
      this.bulkErrorItems.sort(this.compareFunc);
    }
  }

  compareFunc(a: string, b: string) {
    if (a > b) { return -1; }
    if (a < b) { return 1; }
  }
  
}
